import { Component, Vue, Prop as prop, Prop, Watch } from 'nuxt-property-decorator';
import { VNode } from 'vue';
import { mapState } from 'vuex';
import FsLightbox from "fslightbox-vue"


@Component({
    components: {
        reviewMessage: require('./review-message').default,
        reviewField: require('./review-field').default,
        questionField: require('./question-field').default,
        questionList: require('./question-list').default,
        // reviewRules: require('./review-rules.vue').default,
        reviewStats: require('./review-stats').default,
        customPicture: require('~/components/common/simple-picture/').default,
        FsLightbox
    },
    computed: mapState(['user']),
})
export default class ReviewPageComponent extends Vue {

    @prop()
    public productId: number;
    @prop()
    public totalStats: any;

    public user: User;

    public stats = null;

    private loadingTrigger: VNode = null;
    private next: number = null;
    private loading: boolean = false;
    private show = false;
    private rootItems: any[] = [];
    private loaded = false;

    tab = 'reviews'

    @Prop()
    value: number;


    @Watch('value')
    onValueChanged() {
        this.tab = this.value ? 'questions' : 'reviews';
    }

    showIndex = null;
    showLightbox = false;
    showReviewField = false;

    mounted() {}

    public async fetch() {
        const data = await this.$store.dispatch('catalog/GetReviews', {
            id: this.productId,
            next: this.next,
        });

        this.rootItems = data.messages;
        this.stats = data.stats;
    }

    public async loadReviews(loaded: () => void, complete: () => void) {

        if (this.loading || this.loaded) {
            return;
        }

        this.loading = true;

        try {
            const data = await this.$store.dispatch('catalog/GetReviews', {
                id: this.productId,
                next: this.next,
            });

            if (data.last) {
                this.loaded = true;
                complete();
            } else {
                this.next = data.next;
                loaded();
            }
        } catch {
            complete();
        } finally {
            this.loading = false;
        }
    }

    get allPhotos() {
        return this.rootItems.reduce((carry, el) => {

            if (el.photos?.length) {
                carry.push(...el.photos);
            }

            return carry;
        }, []);
    }
    
    get originalPhotos() {
        return this.allPhotos.map((el) => `/upload${el.src}`);
    }
}
